import React from 'react';

/**
 * Development Banner Component
 * Shows when the app is using mock data or in development mode
 */
const DevelopmentBanner = ({ 
  isVisible = true, 
  message = "Development Mode: Using mock data", 
  type = "info" 
}) => {
  if (!isVisible) return null;

  const bannerStyles = {
    info: {
      backgroundColor: '#e3f2fd',
      color: '#1565c0',
      borderColor: '#2196f3'
    },
    warning: {
      backgroundColor: '#fff3e0',
      color: '#ef6c00',
      borderColor: '#ff9800'
    },
    error: {
      backgroundColor: '#ffebee',
      color: '#c62828',
      borderColor: '#f44336'
    }
  };

  const style = bannerStyles[type] || bannerStyles.info;

  return (
    <div 
      style={{
        ...style,
        padding: '8px 16px',
        borderLeft: `4px solid ${style.borderColor}`,
        fontSize: '14px',
        fontWeight: '500',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        marginBottom: '16px',
        borderRadius: '4px'
      }}
    >
      <span style={{ fontSize: '16px' }}>
        {type === 'info' && '🔧'}
        {type === 'warning' && '⚠️'}
        {type === 'error' && '❌'}
      </span>
      <span>{message}</span>
      {import.meta.env.VITE_ENVIRONMENT === 'development' && (
        <span style={{ 
          marginLeft: 'auto', 
          fontSize: '12px', 
          opacity: 0.7 
        }}>
          DEV MODE
        </span>
      )}
    </div>
  );
};

export default DevelopmentBanner;
